import script from "./BaseGDPRLogic.vue?vue&type=script&lang=js"
export * from "./BaseGDPRLogic.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__